// extracted by mini-css-extract-plugin
export default {"wrapper":"Om-z","response":"Pm-z","error":"Qm-z","disabled":"Rm-z","buttons":"Sm-z","feedbackQuestionSection":"Tm-z","yesNoWrapper":"Um-z"};